// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalStepsLine__hFHe1 {
  padding: 12px 25px;
  border-top: 1px solid var(--tables-title-stroke);
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
}

.stepNameItem__sjRkd {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  text-transform: uppercase;
  color: var(--tables-title-text);
  position: relative;
}
.stepNameItem__sjRkd:not(:last-child) {
  margin-right: 18px;
}

.arrowNext__lMNeG {
  margin-left: 10px;
}

.activeStep__l0MuW {
  cursor: pointer;
}

.currentStep__hgCIE {
  font-size: 12px;
  font-weight: 500;
  color: var(--tables-secondary-row-sub-title-text);
  cursor: auto;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/UserModal/components/StepsInfo/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,kBAAA;EACA,gDAAA;EACA,mDAAA;EACA,uCAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;AAzEF;AA2EE;EACE,kBAAA;AAzEJ;;AA6EA;EACE,iBAAA;AA1EF;;AA6EA;EACE,eAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,gBAAA;EACA,iDAAA;EACA,YAAA;AA1EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.modalStepsLine {\n  padding: 12px 25px;\n  border-top: 1px solid var(--tables-title-stroke);\n  border-bottom: 1px solid var(--tables-title-stroke);\n  background: var(--tables-title-surface);\n}\n\n.stepNameItem {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  text-transform: uppercase;\n  color: var(--tables-title-text);\n  position: relative;\n\n  &:not(:last-child) {\n    margin-right: 18px;\n  }\n}\n\n.arrowNext {\n  margin-left: 10px;\n}\n\n.activeStep {\n  cursor: pointer;\n}\n\n.currentStep {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--tables-secondary-row-sub-title-text);\n  cursor: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalStepsLine": `modalStepsLine__hFHe1`,
	"stepNameItem": `stepNameItem__sjRkd`,
	"arrowNext": `arrowNext__lMNeG`,
	"activeStep": `activeStep__l0MuW`,
	"currentStep": `currentStep__hgCIE`
};
module.exports = ___CSS_LOADER_EXPORT___;
